import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./loco.css"
import AnimatedCursor from 'react-animated-cursor';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
    <AnimatedCursor

      innerSize={8}
      outerSize={45}
      innerScale={1}
      outerScale={2}
      outerAlpha={0}
      showSystemCursor={true}
      hasBlendMode={true}
      outerStyle={{
        mixBlendMode: 'difference',
        background: '#ffff'

      }}
    />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
